import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import TextField from '../TextField'
import BranchSelect from 'component/branch/BranchSelect'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'
import Plus from 'images/icon-plus.svg'
import Glyph from 'component/utils/Glyph'
import Select from 'component/Select/Select'
import { objectsEqual, hasEmptyProperties, isEmpty } from 'utils/validations'
import { connect } from 'react-redux'
import * as ircActions from 'action/irc'
import { showSpinner, hideSpinner } from 'action/spinner'
import { bindActionCreators } from 'redux'
import ErrorModal from 'component/Modal/ErrorModal'
import { translate } from 'react-i18next'


const MAX_COUNT = 999

class FormModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.object,
    newValues: PropTypes.object,
    toggleEdit: PropTypes.func,
    isUserMatriz: PropTypes.bool.isRequired,
    fetchPositions: PropTypes.func.isRequired,
    auth: PropTypes.object,
    showSpinner: PropTypes.func,
    hideSpinner: PropTypes.func,
    maxDays: PropTypes.number,
    hideModal: PropTypes.bool.isRequired
  }

  getDepositOptionsParams = (values) => {
    const {user, isUserMatriz} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values, "")
    .then(resp => {
      const depositTypes = resp.data.split(",").map((item) => ({label: item, type:item, positions:[], deposit: item, value: [{label: "", value: ""}]}))
      this.setState({depositTypeOptions: depositTypes})
      
      if(!isUserMatriz) {

        const newState = {...this.state.values}
        newState.positions = [{position: '', deposit: ''}]
        newState.selectedPositions = depositTypes

        this.setState({values: newState, selectedPositions: []  })
      }
    })

  }

  state = {
    depositTypeOptions: [],
    values: {
      dsListName: '',
      positionsPerDay: '',
      period: [],
      idBranch: '',
    
      selectedPositions: [],
      positions: [{ deposit: '', position: [] }]
    },
    modalError: {
      render: false,
      type: null
    },

    positionsValues: [
     
    ]
  }

  componentDidMount() {

    const {isUserMatriz, user} = this.props

    if(!isUserMatriz) {
      this.setState({values: {  ...this.state.values,idBranch: user.locationCode.padStart(4, '0') }})
    }
    const depositTypeParams = {
      dsKey: 'irc.supply.deposit.type',
      nuParameter: 1
    }

    this.getDepositOptionsParams(depositTypeParams)
    const { edit, newValues } = this.props

    if (edit && !edit.inEdit && edit.idInventoryCriteria) {
      this.fetchList(edit.idInventoryCriteria)
    } else if (edit && edit.inEdit && newValues) {
      this.fillFields(newValues)
    }
  }

  fetchList = async (idInventoryCriteria) => {
    const { user, toggleEdit } = this.props

    if (user) {
      this.setState({ loading: true })
      const query = { idInventoryCriteria }

      try {
        const { data } = await new Api(user.dsToken).get(
          API_URL.INVENTORY_CRITERIA_FETCH_ID,
          query
        )
        this.fillFields({
          ...data,
          dsListName: 'Lista Critérios Posições X',
          idBranch: '0001',
          positionsPerDay: '20',
          positions: [
            { deposit: 'RSS', position: 'L01-01-01' },
            { deposit: 'RSS', position: 'J12-01-01' },
            { deposit: 'RSS', position: 'Y12-01-01' },
          ]
        })
      } catch (error) {
        console.error(error)
        toggleEdit(false)
      } finally {
        this.setState({ loading: false })
      }
    }
  }

  fillFields(list) {
    const { values } = this.state

    this.setState({
      values: {
        ...values,
        idInventoryCriteria: list.idInventoryCriteria,
        dsListName: list.dsListName,
        idBranch: list.idBranch,
        period: list.period || [moment(list.dtBegin), moment(list.dtEnd)],
        positionsPerDay: list.positionsPerDay,
        positions: list.positions
      }
    });
  }

  handleChange = (name, value, callback) => {
    this.setState({
      values: {
        ...this.state.values,
        [name]: value
      }
    }, () => callback?.())
  }

  isBtnDisabled() {
    const { values } = this.state
    let disabled = false

    const toValidate = [
      'dsListName',
      'period',
      'idBranch',
      'positionsPerDay',
    ]

    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }

      if (field === 'positionsPerDay' && (values[field] < 1 || values[field] > MAX_COUNT)) {
        disabled = true
      }
    }

    if (!values.positions.find(({ deposit, position }) => deposit.length !== 0 && position.length !== 0)) {
      disabled = true
    }

    if (values.positions.find(({ deposit, position }) => deposit.length !== 0 && position.length === 0)
    ) {
      disabled = true
    }

    if (this.sameValues()) disabled = true

    return disabled
  }

  isEqual(a, b) {
    if (!a && !b) return true

    if ((!a && b) || (a && !b)) return false

    if (a.length === 0 && b.length === 0) return true

    if (a.filter(aObject => b.find(bObject => objectsEqual(bObject, aObject))).length !== a.length) return false

    if (b.filter(bObject => a.find(aObject => objectsEqual(aObject, bObject))).length !== b.length) return false

    return true
  }

  sameValues() {
    const { edit } = this.props
    const { values } = this.state
    let sameValues = true

    const toValidate = [
      'dsListName',
      'idBranch',
      'positionsPerDay',
    ]

    if (!hasEmptyProperties(edit)) {
      for (const field of toValidate) {
        if (values[field] !== edit[field]) sameValues = false
      }

      if (
        !moment(edit.dtBegin).isSame(values.period[0])
        || !moment(edit.dtEnd).isSame(values.period[1])
      ) {
        sameValues = false
      }

      if (!this.isEqual(edit.positions, values.positions)) sameValues = false
    } else {
      sameValues = false
    }

    return sameValues
  }

  formIsEmpty() {
    const { edit } = this.props
    const { values } = this.state
    let isEmpty = true

    if (!hasEmptyProperties(edit)) {
      isEmpty = false
    } else {
      const strings = ['dsListName', 'positionsPerDay', 'idBranch']
      const stringsIsEmpty = strings.filter(string => values[string] !== '').length === 0
      const periodIsEmpty = values.period.length === 0
      const positionIsEmpty = values.positions.length === 1 && values.positions[0].deposit.length === 0 && values.positions[0].position.length === 0

      if (!stringsIsEmpty || !periodIsEmpty || !positionIsEmpty) isEmpty = false
    }

    return isEmpty
  }

  onSubmit = () => {
    const { toggleEdit, onSubmit } = this.props

    const { values } = this.state

    values.dtBegin = values.period[0].format()
    values.dtEnd = values.period[1].format()

    onSubmit(values)

    if (toggleEdit) {
      toggleEdit(false)
    }
  }

  addOption = () => {
    const copy = Array.from(this.state.values.positions)
    copy.push({ deposit: '', position: '' })
    this.setState({
      values: { ...this.state.values, positions: copy }
    })
  }

  removeOption = (i) => {

    const copyOptions = Array.from(this.state.values.positions)
    const removed = copyOptions[i]

    const copySelected = Array.from(this.state.values.selectedPositions).map(selected => selected.deposit === removed.deposit ? {...selected, positions: []} : {...selected})

    const filteredOptions = copyOptions.filter((item) => item.position !== removed.position)
    this.setState({

      values: {
        ...this.state.values,
        selectedPositions: copySelected,
        positions: filteredOptions,
      }
    })
  }

  renderModalError = () => {
    const { translate } = this.props


    return (

      <ErrorModal
        size='sm'
        handleClose={() =>
          this.setState({
            modalError: {
              render: false,
              type: null,
            },
          })
        }
        msg={translate("irc.supply.fetch.positions.error")}
        t={translate}
        center
        buttonText={translate('ok_button')}
      />
    )
  }

  fetchPositions = async (store,type, index ) => {
    const {user, showSpinner, hideSpinner} = this.props
    const {values} = this.state
    const requestBody = {
      addressWharehouseRequest:
      { storeList: [{storeId:store,warehouseType:type}]}
    }

  return new Api(user.dsToken).post(API_URL.IRC_LIST_POSITIONS, requestBody)
  .then(showSpinner())
  .then((response ) => {
    hideSpinner()
    return response
  }).catch(() =>  {
    const copy = Array.from(values.positions)
    copy[index].deposit = ""
    copy[index].position = []
    this.setState({values: {...values, positions: copy}, modalError: {render: true, type: null}})

    hideSpinner()
  })
  }

  renderPositionOptions = () => {
    const { translate } = this.props
    const { positions, idBranch } = this.state.values
    const { values, depositTypeOptions} = this.state
    const depositOptions =
     depositTypeOptions.map(v => v.type).map(value => ({ label: value, value }))

    return (
      <div >
        {positions.map((option, i) => {
            const currentOption = depositTypeOptions.find(pos => pos.type === option.deposit.toString())

            return<div key={i} className='flex'>
              <Select
                disabled={isEmpty(idBranch) }
                label={translate('deposit.type')}
                options={positions.length > 1 ? depositOptions.filter(pos => !positions.some(p => p.deposit === pos.value))  : depositOptions}
                placeholder={translate('select')}
                translate={translate}
                onChange={ async ({ value }) => {


                  const copy = Array.from(values.positions)
                  const option = copy[i]


                  const hasFetchedPositions = depositTypeOptions.find(pos => pos.type === value.toString()).value.filter(val => !hasEmptyProperties(val)).length > 0

                  if(hasFetchedPositions) {
                    const findPreviousSelectedPositions = values.selectedPositions.find(pos => pos.deposit === value.toString())

                    copy[i] = { position: findPreviousSelectedPositions.positions, deposit: value }
                    this.setState({values: {...values, positions: copy}})
                  }

                  else {
                    const response = await this.fetchPositions(idBranch, value, i)

                    if(response.cdStatus === 200) {
                      const listPositions = response.data[0].storageBinList.map(storage => ({label: storage.STORAGEBINID, value: storage.STORAGEBINID}))

                      // add new positions options in selected deposit
                      const newOptions = depositTypeOptions.map(pos => pos.type === value.toString() ? {...pos, value: listPositions } : {...pos})
                      copy[i] = { ...option, deposit: value }
                      this.setState({
                        depositTypeOptions: [...newOptions],
                        values: {...values, positions: copy}
                    })
                    }
                  }
                }}
                value={depositOptions.find(({ value }) => value === option.deposit)}
                required
                fill
                containerClass='margin-right-small'
              />
              <Select

                label={translate('position')}
                options={!isEmpty(currentOption) ? currentOption.value : [] }
                placeholder={translate('select')}
                translate={translate}
                isMulti
                groupOptions
                required
                onChange={(e) => {
                  const copy = Array.from(this.state.values.positions)
                  copy[i] = { ...option, position: isEmpty(e) ? [] : e }
                  const copySelected = Array.from(this.state.values.selectedPositions).map(pos => pos.deposit === currentOption.type ? {...pos, positions: e} : {...pos})
                  this.setState({values: {...this.state.values,positions: copy,  selectedPositions: copySelected},})
                }}

                value={
                  currentOption && !isEmpty(this.state.values.selectedPositions) 
                    ? this.state.values.selectedPositions.find(pos => pos.deposit === currentOption.type)?.positions
                    : []
                }
                
                fill
                disabled={(option.deposit || '').length === 0}
                containerClass='margin-left-small'
              />
              <div className='table-icon-center padding flex align-items-center'>
                <Glyph
                  disabled={positions.length <= 1}
                  type='trash-can'
                  color='danger'
                  customClass='cursor-pointer'
                  onClick={() => this.removeOption(i, option)}
                />
              </div>
            </div>
          })}

        <span
          className={`add-field no-margin ${positions[positions.length - 1].position.length === 0 ? 'add-field-disabled' : ''}`}
          onClick={positions[positions.length - 1].position.length === 0 ? () => { } : () => this.addOption()}
        >
          <img src={Plus} />
          {translate('add.position')}
        </span>
      </div>
    )
  }

  render() {
    const { translate, edit, toggleEdit = () => { }, isUserMatriz, maxDays, user, hideModal } = this.props

    const { values } = this.state

    return (
      <Modal
        invisible={hideModal}
        className={`irc-form-modal`}
        title={hasEmptyProperties(edit) ? translate('position.register') : translate('position.register.edit')}
        cancelButtonText={translate('close')}
        confirmButtonText={translate('save_button_label')}
        disabledBgClickClosing
        isConfirmButtonDisabled={this.isBtnDisabled()}
        isOpen
        noCloseOnConfirm
        onConfirm={this.onSubmit}
        onCloseModal={(this.sameValues() || this.formIsEmpty()) ? () => toggleEdit(false) : () => toggleEdit(true,true)}
      >
        <form action='#' onSubmit={(e) => e.preventDefault()} className='w-100'>
          <div className='w-100'>
            <TextField
              required
              label={translate('irc.name')}
              placeholder={translate('irc.choose-name')}
              name={'dsListName'}
              fill
              onChange={(e) => this.handleChange('dsListName', e.target.value)}
              translate={translate}
              value={values.dsListName}
              validateValue={(v) => Boolean(v)}
            />
          </div>

          <div className='w-100'>
            <BranchSelect
              required
              name='idBranch'
              label={translate('irc.store')}
              placeholder={translate('irc.choose-store')}
              translate={translate}
              onChange={(e) => {
                const {depositTypeOptions} = this.state
                this.handleChange('idBranch', e.target.value.value,() => {
                  const newState = {...this.state.values}
                  // eslint-disable-next-line no-unused-vars
                  const copy = Array.from(this.state.values.positions).map(_ => ({position: "", deposit: ""}))
                  newState.positions = [{position: '', deposit: ''}]
                  newState.selectedPositions = depositTypeOptions

                  this.setState({values: newState, selectedPositions: []  })
                  })
              }

              }
              value={values.idBranch}
              withoutRegions
              attrs={{
                fill: true
              }}
              disabled={!isUserMatriz}
              excludeInactive={true}
            />
          </div>

          <div className='w-100'>
            <NewDateIntervalInput
              minDate={new Date()}
              maxRange={maxDays}
              useMinDate
              label={translate('field.period.hint')}
              required
              initialValue={
                values.period.length > 0 ? values.period : false
              }
              name={'period'}
              t={translate}
              onChange={(e) => this.handleChange('period', e)}
              noSelect
              user={user}
              disableAutoClose
            />
          </div>

          <div className='w-100'>
            <TextField
              notZero
              required
              label={translate('irc.counted.position.per.day')}
              placeholder={translate('irc.type.position.per.day')}
              name={'positionsPerDay'}
              fill
              onChange={(e) => {
                this.handleChange('positionsPerDay', e.target.value)
              }
              }
              mask={[...Array((MAX_COUNT).toString().length)].map(() => ('9')).join('')}
              translate={translate}
              value={values.positionsPerDay}
              validateValue={(v) => v && v.length > 0 && v >= 1 && v <= MAX_COUNT}
              helpText={translate('irc.supply.positions.per.day.help').replace('{to}', MAX_COUNT)}
              errorText={translate('irc.supply.positions.per.day.help').replace('{to}', MAX_COUNT)}
            />
          </div>
          {this.state.modalError.render && this.renderModalError()}
          {this.renderPositionOptions()}

        </form>
      </Modal>
    )
  }
}

const mapStateToProps = ({ircReducer }) => ({
  listPostiion: ircReducer.list.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({...ircActions, showSpinner,hideSpinner}, dispatch)


  const FormModalTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate'
  })(FormModal)

export default  connect(mapStateToProps, mapDispatchToProps) (FormModalTranslated)
export { FormModal }
